// FIN-1154 PE-R14: the consultant app's page events, as product-events-api accepts them. Kept apart
// from the API client so src/lib/analytics.ts can use them without loading the Supabase client.

export interface PageEventPayload {
  id: string;
  name: 'page_viewed' | 'page_left';
  occurredAt: string;
  route: string;
  area: string;
  entityType: string | null;
  entityId: string | null;
  companyId: string;
  sessionId: string;
}

export interface RecordPageEventsResult {
  received: number;
  inserted: number;
}

/** `retryable` is false when sending the same batch again cannot succeed (400/401/403). */
export class ProductEventsApiError extends Error {
  constructor(
    message: string,
    public readonly status: number | null,
    public readonly retryable: boolean,
  ) {
    super(message);
    this.name = 'ProductEventsApiError';
  }
}
